import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Intermittent fasting</title>
                <link rel="canonical" href={route("blogs.second")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Een populaire nieuwe methode om af te vallen is intermittent fasting, ofwel periodiek vasten genoemd. Doordat deze methode nog relatief nieuw is zijn er weinig gegevens bekend over de gezondheidsrisico’s of gezondheidswinst op de lange termijn."
                />
                <meta
                    property="og:description"
                    content="Een populaire nieuwe methode om af te vallen is intermittent fasting, ofwel periodiek vasten genoemd. Doordat deze methode nog relatief nieuw is zijn er weinig gegevens bekend over de gezondheidsrisico’s of gezondheidswinst op de lange termijn."
                />
                <meta property="og:url" content={route("blogs.second")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Intermittent fasting - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/intermittent-fasting.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/intermittent-fasting.webp"
                                    type="image/webp"
                                    alt="Intermittent fasting"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/intermittent-fasting.jpg"
                                    type="image/jpeg"
                                    alt="Intermittent fasting"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/intermittent-fasting.jpg"
                                    alt="Intermittent fasting"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Intermittent fasting
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Een populaire nieuwe methode om af te vallen is
                        intermittent fasting, ofwel periodiek vasten genoemd.
                        Doordat deze methode nog relatief nieuw is zijn er
                        weinig gegevens bekend over de gezondheidsrisico’s of
                        gezondheidswinst op de lange termijn. Toch zien we deze
                        methode steeds vaker voorkomen. Wat houd intermittent
                        fasting in en waarom komt deze methode van diëten steeds
                        meer voor?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is intermittent fasting?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Als we het periodiek vasten noemen, zal de werking
                        misschien al iets vanzelfsprekender zijn. Met
                        intermitten fasting wissel je namelijk periodes van
                        vasten af met periodes van eten. In de periode van
                        vasten mag je wel water en/of thee drinken, maar niks
                        anders drinken of eten. De periodes van vasten en eten
                        wisselen bij verschillende methodes.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        De meeste bekende variant is de 16/8 variant, waarbij
                        periodes van 16 uur vasten afwisselen met periodes van 8
                        uur lang eten. Deze 8 uur kunnen bijvoorbeeld van 10 uur
                        in de ochtend tot 6 uur in de avond of van 12 uur in de
                        middag tot 8 uur in de avond zijn. In deze 8 uur neem je
                        de ‘normale’ hoeveelheid calorieën in die je mag innemen
                        om af te vallen. Buiten deze mag je wel water en/of thee
                        drinken, maar verder mag je niks meer nuttigen.
                        Kortgezegd is het enige wat verandert wanneer je eet,
                        maar verandert er niks aan wat je eet.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Andere methodes zijn de 24 uur vasten-methode en de
                        5/2-methode. Bij de 24 uur vasten-methode ga je 1 of 2
                        keer in de week een periode van vasten gebruiken,
                        waarbij je dus enkel water en/of thee mag drinken maar
                        niks mag eten. Bij de 5/2-methode eet je 5 dagen in de
                        week ‘normaal’, terwijl je de andere 2 dagen heel erg
                        weinig eet (zo’n 500 á 600 calorieën).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom zou je intermittent fasting gebruiken?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Intermittent fasting zou vele voordelen hebben. Zo zou
                        het helpen met extra gewichtsverlies, het verbeteren van
                        je bloedsuikerspiegel, het verminder van de kans op
                        hartziektes en zou het zelfs de kans op bepaalde
                        neurogeneratieve ziektes als Parkinson en Alzheimer
                        kunnen verminderen. De vraag is echter of dit waar is.{" "}
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn een wel aantal voordelen van intermittent
                        fasting. Ten eerste verbetert het je
                        insulinegevoeligheid. Als je koolhydraten consumeert
                        maakt je lichaam insuline aan om de suikers uit je bloed
                        op te nemen. Hoe vaker je koolhydraat consumeert, hoe
                        vaker je lichaam insuline moet aanmaken en hoe minder
                        gevoelig je word voor insuline. Je lichaam moet immers
                        steeds meer insuline produceren. In extreme vorm kan dit
                        leiden tot diabetes, omdat je lichaam insuline tekort
                        komt. Bij intermittent fasting heb je minder insuline
                        pieken op een dag, wat je insulinegevoeligheid ten goede
                        komt.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ten tweede stijgen de waardes van het groeihormoon.
                        Hierdoor zullen alle weefsels die vet als brandstof
                        kunnen gebruiken dit ook gaan doen, wat de
                        vetverbranding ten goede komt. Nu is het wel zo dat die
                        toename van het groeihormoon past laat in de periode van
                        vasten optreedt. Dus hoe langer je periode van vasten
                        is, hoe meer effect je hiervan merkt.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ten derde verhoogt het de vetverbranding. Door maar in
                        beperkte periodes te eten zorg je ervoor dat je lichaam
                        minder insulinepieken heeft. Hierdoor produceert je
                        lichaam bepaalde hormonen zoals noradrenaline. Een van
                        de effecten van noradrenaline is het vrijmaken van
                        vetzuren uit de vetcellen om deze om te zetten tot
                        energie. Door minder insulinepieken heeft je lichaam dus
                        meer tijd om je vetreserves aan te spreken.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Heeft intermittent fasting effect?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Intermittent fasting is een dieetmethode. Het doel van
                        een dieetmethode is het afvallen van gewicht of
                        vetverlies. Hiermee zou je de vraag met ja beantwoorden,
                        omdat je met intermittent fasting inderdaad zult
                        afvallen als je deze goed hanteert. Echter komt dit
                        voornamelijk doordat je hiermee een calorietekort
                        hanteert. Ten opzichte van een normaal dieet waarbij je
                        hetzelfde calorietekort hanteert maar gedurende de hele
                        dag eet is er geen significant verschil tussen een
                        regulier dieet en intermittent fasting op het gebied van
                        gewichtsverlies[1].
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het allerbelangrijkste bij het afvallen is dat je een
                        calorietekort hanteert. Dit kun je op vele methodes
                        doen, waarvan intermittent fasting er een is.
                        Intermittent fasting heeft een aantal voordelen, maar op
                        het gebied van extra gewichtsverlies zal het geen groot
                        verschil geven met een normaal dieet. Daarnaast zijn de
                        lange termijn effecten op de gezondheid nog niet
                        duidelijk in beeld doordat intermittent fasting een vrij
                        nieuwe methode is.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Uiteindelijk moet je een methode vinden die goed bij jou
                        past en die jij goed vol kunt houden. Kijk je niet blind
                        op wat in theorie werkt, maar vind uit wat in de
                        praktijk het beste resultaat voor jou geeft. Zo kun je
                        intermittent fasting gaan proberen, en kijken of dit
                        voor jou een geschikte methode is om resultaat te gaan
                        behalen.
                    </p>
                    <p className="mt-4 text-gray-100 italic">
                        [1] Seimon, R. V., Roekenes, J. A., Zibellini, J., Zhu,
                        B., Gibson, A. A., Hills, A. P., … & Sainsbury, A.
                        (2015).{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/26384657/"
                            target="_blank"
                            className="text-we-are-yellow"
                        >
                            Do intermittent diets provide physiological benefits
                            over continuous diets for weighth loss? A systematic
                            review of clinical trials.{" "}
                        </a>{" "}
                        Molecular and cellular endocrinology, 418, 153-172.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
